// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + {"225":"very-logo","305":"ocean-logo","467":"ASOS-logo","638":"capital-one-logo","749":"littlewoods-logo","766":"think-money-logo","908":"luma-logo"}[chunkId] + "." + {"225":"e46cc6bd","305":"bfc8e259","467":"996aa17e","638":"9574bd27","749":"595958a1","766":"2963348e","908":"977a0114"}[chunkId] + ".chunk.js";
};